import { createComponent } from '@carvana/merch-components';
import { useContext, useState } from 'react';
import { Tag as TagType } from '@/srp/MainLayout/constants';
import useRemoveFilterTag from '@/srp/MainLayout/useRemoveFilterTag';
import FilterEvents from '~/constants/srp/events';
import SearchSource from '~/constants/srp/SearchSource';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import Close from '~/icons/srp/Close';

const Pill = createComponent('button', {
  className: `
    flex
    flex
    min-h-[34px]
    min-h-[34px]
    items-center
    gap-4
    gap-4
    whitespace-nowrap
    rounded
    border
    border
    border-solid
    border-solid
    border-grey-3
    border-grey-3
    bg-white
    bg-white
    py-4
    pl-12
    pr-8
    text-blue-6
    transition-colors
    duration-300
    duration-300
    tl-body-s
    hover:bg-transparent
    hover:bg-transparent
    focus:border-grey-3
    focus:border-grey-3
    l:whitespace-normal
 `
});

type OwnProps = {
  filterTag: TagType;
};

export default function Tag({ filterTag }: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const removeTag = useRemoveFilterTag(filterTag);
  const [show, setShow] = useState(true);
  const trackEvent = useTrackEvent();

  return show ? (
    <Pill
      data-analytics-id={null}
      data-qa="remove-applied-filter"
      key={filterTag.tagName}
      onClick={() => {
        setSearchSource(SearchSource.TagRemoved);
        setShow(false);
        removeTag();
        trackEvent(FilterEvents.removedFilter, {
          item: 'applied tag',
          label: filterTag.facetKey,
          value: filterTag.tagName
        });
      }}
    >
      {filterTag.tagName}
      <Close className="close-icon h-[16px] w-[16px] fill-blue-6" />
    </Pill>
  ) : null;
}
